const standardConfig = {
    radio: {
        key: "radio",
        label: "单选",
        type: "radio",
        icon: "fa-dot-circle-o",
        isBase: true,
        list: [],
        options: {},
    },
    checkbox: {
        key: "checkbox",
        label: "多选",
        type: "checkbox",
        icon: "fa-check-square-o",
        isBase: true,
        list: [],
        options: {},
    },
    input: {
        key: "input",
        label: "输入框",
        type: "input",
        icon: "fa-file-o",
        isBase: true,
        options: {},
    },
    textarea: {
        key: "textarea",
        label: "多行输入框",
        type: "textarea",
        icon: "fa-align-left",
        isBase: true,
        options: {
            is_full: true
        }
    },
    number: {
        key: "number",
        label: "数字",
        type: "number",
        icon: "fa-sort-numeric-asc",
        isBase: true,
        options: {},
    },
    select: {
        key: "select",
        label: "下拉选择",
        type: "select",
        icon: "fa-caret-down",
        isBase: true,
        list: [],
        options: {},
    },
    date: {
        key: "date",
        label: "日期选择器",
        icon: "fa-calendar",
        isBase: true,
        type: "date",
        options: {},

    },
    upload: {
        key: "upload",
        label: "上传",
        type: "upload",
        icon: "fa-upload",
        isBase: true,
        options: {
            is_full: true,
            fileList: []
        }
    }
}
const filterSelectList = (list, alias) => {
    if (!Array.isArray(list) || !list.length) {
        console.warn('数据格式错误')
        return
    }
    let arr = []
    if (alias === 'nokey') {
        arr = Array.from(list, item => {
            return {text: item, value: item}
        })
    } else if (alias !== undefined) {
        arr = Array.from(list, item => {
            return {text: item[alias.text], value: item[alias.value]}
        })
    } else {
        arr = list
    }
    return arr
}
const filterRule = (item) => {
    let rule = item.rule || {}
    let rules = []
    switch (item.type) {
        case 'radio':
        case 'checkbox':
        case 'select':
        case 'date':
        case 'emp-select':
        case 'leader-select':
        case 'client':
        case 'client_code':
        case 'project':
        case 'project_code':
        case 'contract':
        case 'locale':
        case 'budget':
            if (rule.required) {
                rules.push({required: true, message: `请选择${item.label}`, trigger: 'blur'})
            }
            break
        case 'contract-maintenance-code':
            if (rule.required) {
                rules.push({required: true, message: `请选择${item.label}`, trigger: 'blur'})
            }
            break
        case 'number':
        case 'money':
            const numberValid = (paramrule, value, callback) => {
                let rule = Object.assign({}, {
                    required: false,
                    length: {},
                    decimal: item.type === 'number' ? 0 : 2
                }, item.rule)
                let tip = item.type === 'number' ? '数字' : '金额'
                if (value === '' || value === undefined || value === null) {
                    if (rule.required) {
                        callback(new Error('不能为空'))
                        return
                    } else {
                        callback()
                        return
                    }

                }
                if (isNaN(value)) {
                    callback(new Error(`请输入${tip}`))
                    return
                }
                let num = Number(value)
                if (rule.length && item.type === 'number') {
                    let isMin = rule.length.min !== undefined ? true : false
                    let isMax = rule.length.max !== undefined ? true : false
                    let min = rule.length.min
                    let max = rule.length.max
                    if (!isMin && !isMax) {
                        callback()
                        return
                    }
                    if (isMin && isMax && (num < min || num > max)) {
                        callback(new Error(`${tip}在 ${min} 到 ${max} 之间`))
                        return
                    }
                    if (isMin && num < min) {
                        callback(new Error(`${tip}不能小于 ${min}`))
                        return
                    }
                    if (isMax && num > max) {
                        callback(new Error(`${tip}不能大于 ${min}`))
                        return
                    }
                }
                let arr = value.split('.')
                if (arr[1] && rule.decimal && (arr[1].length > rule.decimal)) {
                    callback(new Error(`${tip}不能超过${rule.decimal}位小数`))
                    return
                }

                callback()
            }
            rules.push({validator: numberValid, trigger: 'blur'})
            break
        default:
            if (rule.required) {
                rules.push({required: true, message: `请输入${item.label}`, trigger: 'blur'})
            }
            if (rule.length) {
                let isMin = rule.length.min !== undefined ? true : false
                let isMax = rule.length.max !== undefined ? true : false
                let min = rule.length.min
                let max = rule.length.max
                if (!isMin && !isMax) {
                    break
                }
                if (isMin && isMax) {
                    rules.push({min, max, message: `长度在 ${min} 到 ${max} 个字符`, trigger: 'blur'})
                }
                if (isMin) {
                    rules.push({min, message: `长度不能少于 ${min} 个字符`, trigger: 'blur'})
                }
                if (isMax) {
                    rules.push({max, message: `长度不能大于 ${max} 个字符`, trigger: 'blur'})
                }
            }
            break
    }
    return rules
}
const configMerge = (config) => {
    let obj = config ? JSON.parse(JSON.stringify(config)) : []
    for (let i = 0; i < obj.length; i++) {
        let item = obj[i]
        if (item.type !== undefined) {
            if (['form-group', 'project-group', 'client-group'].includes(item.type)) {
                let model = {}
                item.options = Object.assign({}, standardConfig[item.type].options, item.options)
                item = Object.assign({}, standardConfig[item.type], item)
                item.group.map(groupitem => {
                    if (groupitem.type === 'emp-select-multi') {
                        model[groupitem.key] = []
                    }
                })
                item.model = [model]
                obj[i] = item
            } else {
                if (item.list) {
                    item.list = filterSelectList(item.list, item.listAlias)
                }
                item.rule = filterRule(item)
                if (!standardConfig[item.type]) {
                    alert(`没有${item.type}类型的表单`)
                    return
                }
                item.options = Object.assign({}, standardConfig[item.type].options, item.options)
                item = Object.assign({}, standardConfig[item.type], item)
                obj[i] = item
            }
        }

    }
    return obj
}
export {standardConfig, configMerge}
